import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import React from 'react';
import './App.css';
import SessionPanel from "./components/SessionPanel";
import {all as locales} from "primelocale";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-dark-indigo/theme.css";
import "primeflex/primeflex.css";
import "primeflex/themes/primeone-dark.css";
import {addLocale, locale} from "primereact/api";
import LeaderboardDetails from "./components/LeaderboardDetails";


function App() {
    addLocale("en", locales["en"]);
    locale("en");


    return (

        <Router>
            <Routes>
                <Route path="/" element={<SessionPanel/>}/>
                <Route path="/:uuid" element={<LeaderboardDetails/>}/>
            </Routes>
        </Router>


    );
}

export default App;
